import React from 'react';
import {View} from '@ab/components';
import Model from '../models/main.m';

class Main extends View {
    fetchBeforeRender = ['model'];

    constructor() {
        super();

        this.model = new Model();
    }

    render() {
        return <div />;
    }

    componentReady() {
        this.load();
    }

    load = async () => {
        if (!this.isWidgetLoaded()) {
            window.senderCallback = this.initWidget;

            (function(d, s, id) {
                let js,
                    fjs = d.getElementsByTagName(s)[0];
                js = d.createElement(s);
                js.id = id;
                js.src = 'https://widget.a-bank.com.ua/build/init.js';
                fjs.parentNode.insertBefore(js, fjs, 'sender-widget');
            })(document, 'script');
        } else {
            this.initWidget();
            this.isOnline = true;
        }

        return this;
    };

    isWidgetLoaded = () => {
        return !!window.document.querySelector('#_sender_widget');
    };

    initWidget = () => {
        if (window.SenderWidget) {
            let model = this.getModel();

            this.senderWidget = window.SenderWidget;

            this.senderWidget.on('widgetIsReady', () => {
                this.isOnline = true;
            });

            this.senderWidget.init({
                companyId: 'i602158949',
                lang: this.props.lang,
                showButton: true,
                autostart: false,
                resizable: true,
                height: 650,
                width: 400,
                template: 'green',
                auth: model.get('auth'),
                welcomeModel: {
                    origin: 'А-Банк',
                    url: 'http...',
                },
            });
        }
    };

    static displayName = 'Help.Views.Main';
}

export default Main;
